
export const SCHOOLS_WITH_REPORT_CARD_POSTING = ['BPIS'];

export const canPostReportCardToParents = (school?: string): boolean =>
  !!school && SCHOOLS_WITH_REPORT_CARD_POSTING.includes(school);
